module.exports = __webpack_public_path__ + "static/media/cloud.8fb1e212.svg";